// extracted by mini-css-extract-plugin
module.exports = {"brand":"PmhsoF","link":"rdt-Mx","img":"c3t_hxd"};